import type { EChartsOption } from 'echarts';
import type { BaseViewModelState } from '@app/shared/view-model/base-view-model';

export type ScoreLevel = 'A' | 'B' | 'C' | 'UNKNOWN';
export type ChartEntry = [string, number];

export interface UserOption {
  userId: string;
  displayName: string;
  code: string;
  name: string;
}

export interface TomassFilterState {
  startDate: Date | null;
  endDate: Date | null;
  selectedUserIds: string[];
}

export interface FrequencyRow {
  dateKey: string;
  dateLabel: string;
  measurementCount: number;
  accountCount: number;
  accountNames: string[];
  geohashes: string[];
  estimatedRegions: string[];
  scoreA: number;
  scoreB: number;
  scoreC: number;
  scoreUnknown: number;
}

export interface MapMarkerData {
  geohash: string;
  lat: number;
  lng: number;
  totalCount: number;
  uniqueUserCount: number;
  scoreA: number;
  scoreB: number;
  scoreC: number;
  scoreUnknown: number;
  scoreARatio: number;
  scoreBRatio: number;
  scoreCRatio: number;
  seniorRatio: number;
  avgAgeGroup: string;
  latestCreatedAt: string;
}

export interface TomassKpi {
  recordCount: number;
  userCount: number;
  avgAgeGroup: string | null;
  avgPst: number | null;
  avgGpst: number | null;
}

export interface ChartLegendItem {
  label: string;
  count: number;
  percentage: string;
  color: string;
}

export interface TomassSummaryState extends BaseViewModelState {
  hasLoaded: boolean;
  hasAggregated: boolean;
  filters: TomassFilterState;
  userOptions: UserOption[];
  kpi: TomassKpi;
  frequencyRows: FrequencyRow[];
  mapMarkers: MapMarkerData[];
  ageChartOption: EChartsOption;
  ageChartLegend: ChartLegendItem[];
  genderChartOption: EChartsOption;
  genderChartLegend: ChartLegendItem[];
  crackerRatioOption: EChartsOption;
  crackerRatioLegend: ChartLegendItem[];
  crackerHistogramOption: EChartsOption;
}

/** ECharts requires raw color strings — CSS variables are not supported. */
export const TOMASS_CHART_COLORS = {
  age: [
    '#2f80ed', '#1d4ed8', '#f59e0b', '#ef4444',
    '#10b981', '#8b5cf6', '#14b8a6', '#f97316', '#64748b',
  ],
  gender: ['#2f80ed', '#ef4444', '#94a3b8'],
  cracker: ['#2f80ed', '#1d4ed8', '#f59e0b', '#94a3b8'],
  scoreA: '#10b981',
  scoreB: '#f59e0b',
  scoreC: '#ef4444',
  unknown: '#94a3b8',
} as const;
